export default __webpack_public_path__ + "static/media/sleeping-icon.3ebe620c.svg";